// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Estilos gerais */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  text-decoration: none;
}

html,
body {
  font-family: "inter", sans-serif;
}

.container-wrapper {
  /* Estilo da caixinha */
  border: 1px solid #000;
  padding: 20px; /* Ajuste conforme necessário */

  /* Estilo do conteúdo interno (se desejar) */

}

.container2 {
  height: 100vh;
  display: flex;
  align-items: center;
  background-size: cover;
  justify-content: center;
  flex-direction: column;
 
}

.container2 .register-heading {
  font-size: 1.5rem;
  margin: 20px 0;
}

.container2 .register-form {
  width: 100%;
  max-width: 500px;
}

.container2 .form-group {
  margin-bottom: 20px;
}

.container2 .btn-primary {
  width: 100%;
  max-width: 200px;
  margin-top: 20px;
}

@media screen and (max-width: 768px) {
  .container2 .register-heading {
    font-size: 1.2rem;
  }
}

.container .header {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 40px;
}

.form-container {
  width: 30%;
}

.InputContainer {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}

.InputContainer label {
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  margin-bottom: 8px;
}

/* Estilos para o campo "Cargo" */
.button-container {
  width: 100%;
}

.recovery {
  color: #000;
}


.white-text {
  color: #000000;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5); /* Fundo escuro semitransparente para o overlay */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: #ffffff; /* Fundo branco sólido para a modal */
  padding: 20px;
  border-radius: 8px;
  max-width: 400px;
  width: 100%;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1); /* Sombra para destacar a modal */
  z-index: 1001; /* Certifique-se de que a modal está acima do overlay */
}

.modal-content h3 {
  margin-bottom: 20px;
  font-size: 1.5rem;
  text-align: center;
}

.modal-content .form-group {
  margin-bottom: 15px;
}

.modal-content input {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
}

.modal-content .btn {
  padding: 10px 20px;
  font-size: 1rem;
  border-radius: 4px;
}

.modal-content .btn-secondary {
  background: #ccc;
  border: none;
  color: #000;
}

.modal-content .btn-primary {
  background: #007bff;
  border: none;
  color: #fff;
}

.text-danger {
  color: red;
}

.text-success {
  color: green;
}`, "",{"version":3,"sources":["webpack://./src/Home/Login.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,aAAa,EAAE,+BAA+B;;EAE9C,4CAA4C;;AAE9C;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,sBAAsB;;AAExB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,iCAAiC;AACjC;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;;AAGA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B,EAAE,iDAAiD;EACjF,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mBAAmB,EAAE,qCAAqC;EAC1D,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,yCAAyC,EAAE,iCAAiC;EAC5E,aAAa,EAAE,uDAAuD;AACxE;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd","sourcesContent":["/* Estilos gerais */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  text-decoration: none;\n}\n\nhtml,\nbody {\n  font-family: \"inter\", sans-serif;\n}\n\n.container-wrapper {\n  /* Estilo da caixinha */\n  border: 1px solid #000;\n  padding: 20px; /* Ajuste conforme necessário */\n\n  /* Estilo do conteúdo interno (se desejar) */\n\n}\n\n.container2 {\n  height: 100vh;\n  display: flex;\n  align-items: center;\n  background-size: cover;\n  justify-content: center;\n  flex-direction: column;\n \n}\n\n.container2 .register-heading {\n  font-size: 1.5rem;\n  margin: 20px 0;\n}\n\n.container2 .register-form {\n  width: 100%;\n  max-width: 500px;\n}\n\n.container2 .form-group {\n  margin-bottom: 20px;\n}\n\n.container2 .btn-primary {\n  width: 100%;\n  max-width: 200px;\n  margin-top: 20px;\n}\n\n@media screen and (max-width: 768px) {\n  .container2 .register-heading {\n    font-size: 1.2rem;\n  }\n}\n\n.container .header {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-bottom: 40px;\n}\n\n.form-container {\n  width: 30%;\n}\n\n.InputContainer {\n  display: flex;\n  align-items: flex-start;\n  flex-direction: column;\n}\n\n.InputContainer label {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 19px;\n  margin-bottom: 8px;\n}\n\n/* Estilos para o campo \"Cargo\" */\n.button-container {\n  width: 100%;\n}\n\n.recovery {\n  color: #000;\n}\n\n\n.white-text {\n  color: #000000;\n}\n\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5); /* Fundo escuro semitransparente para o overlay */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.modal-content {\n  background: #ffffff; /* Fundo branco sólido para a modal */\n  padding: 20px;\n  border-radius: 8px;\n  max-width: 400px;\n  width: 100%;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1); /* Sombra para destacar a modal */\n  z-index: 1001; /* Certifique-se de que a modal está acima do overlay */\n}\n\n.modal-content h3 {\n  margin-bottom: 20px;\n  font-size: 1.5rem;\n  text-align: center;\n}\n\n.modal-content .form-group {\n  margin-bottom: 15px;\n}\n\n.modal-content input {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 1rem;\n}\n\n.modal-content .btn {\n  padding: 10px 20px;\n  font-size: 1rem;\n  border-radius: 4px;\n}\n\n.modal-content .btn-secondary {\n  background: #ccc;\n  border: none;\n  color: #000;\n}\n\n.modal-content .btn-primary {\n  background: #007bff;\n  border: none;\n  color: #fff;\n}\n\n.text-danger {\n  color: red;\n}\n\n.text-success {\n  color: green;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
